import {defineMessages, FormattedMessage} from 'react-intl';
import {view} from '@sail/ui/deprecated';
import {MetaRow} from './MetaRow';

const messages = defineMessages({
  translatedConversation: {
    id: 'conversations_ui.chat.row.translationRow',
    description: "Message to show in a conversation when it's translated.",
    defaultMessage: 'Agent responses are translated from English',
  },
});

export const TranslationRow = () => (
  <view.div data-testid="translation-row">
    <MetaRow>
      <FormattedMessage {...messages.translatedConversation} />
    </MetaRow>
  </view.div>
);

export default TranslationRow;
